<template>
  <Modal title="分配课程顾问" v-model="visible">
    <Form ref="assignAdviserForm" class="form"
          :model="adviserParam" :rules="adviserRule"
          :label-width="80">
      <Row>
        <Col :span="22">
        <Form-item label="学生">
          <Tag v-for="item in userList" :key="item.id" :name="item.id" >
            {{ item.uid + ' - ' + item.nickName }}
          </Tag>
        </Form-item>
        </Col>
        <Col :span="16">
        <Form-item label="课程顾问" prop="adviserId">
          <AdminUserSelect adminGroupCode="adviser"
                           v-model="adviserParam.adviserId"></AdminUserSelect>
        </Form-item>
        </Col>
      </Row>
    </Form>
    <div slot="footer">
      <Button type="text" size="large" @click="visible=false">取消</Button>
      <Button type="primary" size="large" :loading="loadingAssignAdviser" @click="assignAdviser">分配</Button>
    </div>
  </Modal>
</template>
<script>
  export default {
    name: 'AssignAdvierTreModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      userList: {
        type: Array
      },
      successCallback: {
        type: Function
      }
    },
    data () {
      return {
        visible: this.value,
        loadingAssignAdviser: false,
        adviserParam: {
          adviserId: '',
          resourceStatus: 2
        },
        adviserRule: {
          adviserId: [
            { type: 'integer', required: true, message: '请选择课程顾问', trigger: 'blur' }
          ]
        },
      }
    },
    methods: {
      assignAdviser () {
        let self = this

        self.$refs.assignAdviserForm.validate((valid) => {
          if (!valid) {
            return
          }
          let idList = self.userList.map(function (element) {
            return element.uid
          })
          self.loadingAssignAdviser = true
          let params = {ids: idList.join(','), adviserId: self.adviserParam.adviserId, resourceStatus: self.adviserParam.resourceStatus}
          self.$http.get('/user/updateAdviserTre', {params: params}).then(function (res) {
            if (res && res.data > 0) {
              self.successCallback()
              self.visible = false
            }
            self.loadingAssignAdviser = false
          }).catch(function (e) {
            self.visible = false
            self.loadingAssignAdviser = false
          })
        })
      }
    },
    watch: {
      value (val) {
        this.visible = val
      },
      visible (val) {
        if (val === false) {
          this.adviserParam.adviserId = ''
        }
        this.$emit('input', val)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// AssignAdviserTreModal.vue?2aacde62